import { useEffect, useRef, useSyncExternalStore } from 'react';
import { useIsMutating } from '@tanstack/react-query';
import { isOutdated, isSafeToReload, subscribeOutdated } from '../lib/appVersion.js';
import { useUi } from './ui.js';

/** 気づいてから最初に読み込み直すまでの猶予。トーストを読む時間を取る。画面が裏にあるときは待たない。 */
const GRACE_MS = 5000;
const CHECK_MS = 1000;

/**
 * 新しい版が配備されたら、作業の区切りで自動的に読み込み直す。
 * 読み込み直してもログインは保たれ、URL（画面）もそのまま。患者情報は端末に残していないので失うものはない。
 */
export function AutoUpdate({ reload = () => window.location.reload() }: { reload?: () => void }) {
  const outdated = useSyncExternalStore(subscribeOutdated, isOutdated, isOutdated);
  const { toast } = useUi();
  const mutating = useIsMutating();
  const mutatingRef = useRef(mutating);
  mutatingRef.current = mutating;

  useEffect(() => {
    if (!outdated) return;
    toast(
      <>
        新しい版に更新します
        <small>入力中の内容がなければ、まもなく自動で読み込み直します</small>
      </>,
      { icon: 'system_update', ms: GRACE_MS + 3000 },
    );
    const started = Date.now();
    const timer = window.setInterval(() => {
      if (!document.hidden && Date.now() - started < GRACE_MS) return;
      if (isSafeToReload(mutatingRef.current)) {
        window.clearInterval(timer);
        reload();
      }
    }, CHECK_MS);
    return () => window.clearInterval(timer);
  }, [outdated, toast, reload]);

  return null;
}
